import { graficoValorQuantidadeClassificacoesStyles } from './GraficoValorQuantidadeClassificacoes.style'

export function graficoValorQuantidadeClassificacoesIO() {
  return {
    styles: graficoValorQuantidadeClassificacoesStyles
  }
}

export type GraficoValorQuantidadeClassificacoesIO = ReturnType<typeof graficoValorQuantidadeClassificacoesIO>
